import { defineStore } from 'pinia';
import { authApi } from '../api/auth';
import { loadAuth, saveAuth, clearAuth } from '../api/client';

export const useAuthStore = defineStore('auth', {
  state: () => ({
    user: null,
    account: null,
    initialized: false,
  }),
  getters: {
    isAuthenticated: state => Boolean(state.user && state.account),
  },
  actions: {
    restoreSession() {
      if (this.initialized) return;
      this.initialized = true;
      const data = loadAuth();
      if (!data?.user || !data?.account) return;
      this.user = data.user;
      this.account = data.account;
    },
    async signup(payload) {
      const { data, headers } = await authApi.signup(payload);
      this.persist(data, headers);
      return data;
    },
    async login(payload) {
      const { data, headers } = await authApi.login(payload);
      this.persist(data, headers);
      return data;
    },
    logout() {
      this.user = null;
      this.account = null;
      clearAuth();
    },
    persist(data, headers) {
      this.user = data.user;
      this.account = data.account;
      saveAuth({
        user: data.user,
        account: data.account,
        accountId: data.account.id,
        headers: {
          'access-token': headers['access-token'],
          client: headers.client,
          uid: headers.uid,
          expiry: headers.expiry,
          'token-type': headers['token-type'] || 'Bearer',
        },
      });
    },
  },
});
